import useSavePackaging from "../../useSavePacking";

const SalesView = ({ pkg, disabled }) => {
  const marketing = JSON.parse(pkg.marketing);
  const { state, onChange, loading } = useSavePackaging(
    pkg.id,
    "marketing",
    marketing,
  );

  return (
    <div className="-mx-2 mt-4">
      <table>
        <tbody>
          <tr>
            <td className="text-orange-500 font-semibold">Jordan</td>
            <td></td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Initial packaging and/or display box for approval:</td>
            <td className="text-right">
              <input
                type="checkbox"
                id="initialApproval"
                checked={state.initialApproval}
                disabled={disabled}
                onChange={(e) =>
                  onChange("initialApproval", !state.initialApproval)
                }
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Product sample for approval:</td>
            <td className="text-right">
              <input
                type="checkbox"
                id="productApproval"
                disabled={disabled}
                checked={state.productApproval}
                onChange={(e) =>
                  onChange("productApproval", !state.productApproval)
                }
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Final approval:</td>
            <td className="text-right">
              <input
                type="checkbox"
                id="finalApproval"
                checked={state.finalApproval}
                disabled={disabled}
                onChange={(e) =>
                  onChange("finalApproval", !state.finalApproval)
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SalesView;
